const wx = window.wx;
// 微信分享
function getShare(that,configObj){
    //获取微信分享配置参数传url不包括#后hash参数，需进行过滤，否则签名会匹配错误
    // let isIOS = function() {
    //     var isIphone = navigator.userAgent.includes('iPhone');
    //     var isIpad = navigator.userAgent.includes('iPad');
    //     return isIphone || isIpad;
    // }
    var ourl =  window.location.href.split('#')[0]
    var shlink = configObj.link || window.location.href.split('#')[0];
    // if(isIOS()){
    //     //解决ios微信内部分享单页面记录初始url，如果用location.href，签名会匹配错误
    //     ourl = localStorage.getItem('shurl')
    //     //解决ios分享链接配置失效问题，分享链接配置时间戳参数
    //     shlink = shlink+'&timestamp='+ new Date().getTime()
    // }
    //获取微信appid
    that.$api.common.getShareConfig({url: ourl}).then(res => {
        if(res.success){
            //获取配置参数
            wx.config({
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timeStamp,
                nonceStr: res.data.nonce,
                signature: res.data.signature,
                jsApiList: [
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                    'checkJsApi',
                ],
                openTagList: ['wx-open-launch-app']
            });
            
            wx.ready(function (){
                wx.checkJsApi({
                    jsApiList: ['wx-open-launch-app', 'updateAppMessageShareData'],
                    success: function (res) {
                        console.log('可用')
                    },
                    fail: (err) => {
                        console.log(err, '不可用')
                    }
                })
                //分享朋友以及qq
                wx.updateAppMessageShareData({
                    title: configObj.title, // 分享标题
                    desc: configObj.desc, // 分享描述
                    link: shlink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: configObj.imgUrl, // 分享图标
                    success: function () {
                        // 用户点击了分享后执行的回调函数
                        console.log('成功')
                        // $.post("$ctx/activity/shareCount.do",{"unionid":"$!unionid"},function(){});
                    }
                });
                //分享朋友圈以及空间
                wx.updateTimelineShareData({
                    title: configObj.title, // 分享标题
                    link: shlink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: configObj.imgUrl, // 分享图标
                    success: function () {
                        // 用户点击了分享后执行的回调函数
                        console.log('成功')
                        // $.post("$ctx/activity/shareCount.do",{"unionid":"$!unionid"},function(){});
                    }
                })
            });
        }
    })
}
export default {
    getShare
}
